module.exports = __webpack_public_path__ + "img/revistas_licicon.3a94af92.png";